
// Load user data from localStorage if available
function loadUserDataFromStorage() {
  try {
    const storedUser = localStorage.getItem('netwrck_user');
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      if (parsed && parsed.id && parsed.email) {
        window.userData = parsed;
        return true;
      }
    }
  } catch (e) {
    console.warn('[AUTH-MODAL] Could not load from localStorage:', e);
  }
  return false;
}

// Ensure userData is always defined as an object
if (!loadUserDataFromStorage()) {
  window.userData = window.userData || {};
}

// Sanitize redirect URLs to prevent off-site redirects
function sanitizeRedirectUrl(url) {
  if (!url || url === '') return '/';

  // Remove any leading/trailing whitespace
  url = url.trim();

  // If it's already just a path, return it
  if (url.startsWith('/') && !url.startsWith('//')) {
    return url;
  }

  try {
    var parsed = new URL(url, window.location.origin);

    if (parsed.origin === window.location.origin) {
      return parsed.pathname + parsed.search + parsed.hash;
    }

    // Allow same registrable-domain subdomains (e.g. editor.ebank.nz <-> ebank.nz)
    var apexes = ['ebank.nz', 'netwrck.com', 'v5games.com'];
    var host = parsed.hostname.toLowerCase();
    var cur = window.location.hostname.toLowerCase();
    if (
      (parsed.protocol === 'https:' || parsed.protocol === 'http:') &&
      apexes.some(function (a) {
        return (
          (host === a || host.endsWith('.' + a)) &&
          (cur === a || cur.endsWith('.' + a))
        );
      })
    ) {
      return parsed.toString();
    }

    console.warn('[AUTH-MODAL] Blocked off-site redirect to:', url);
    return '/';
  } catch (e) {
    // If URL parsing fails, treat as a path
    if (url.startsWith('/')) {
      return url;
    }
    return '/';
  }
}

function generateRandomString(length) {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

function updateUIAfterAuth() {

  var loginLinks = document.querySelectorAll('.login-modal-link, .login-link, .header-login-signup');
  var signupLinks = document.querySelectorAll('.signup-link');
  var accountLinks = document.querySelectorAll('.account-link, .header-account');
  var logoutLinks = document.querySelectorAll('.header-login-signout');

  loginLinks.forEach(function (link) {
    link.style.display = 'none';
  });
  signupLinks.forEach(function (link) {
    link.style.display = 'none';
  });

  accountLinks.forEach(function (link) {
    link.style.display = '';
  });
  logoutLinks.forEach(function (link) {
    link.style.display = '';
  });

  if (accountLinks.length === 0) {
    var headerNav = document.querySelector('.mdl-navigation');
    if (headerNav) {
      var accountLink = document.createElement('a');
      accountLink.className = 'mdl-navigation__link account-link';
      accountLink.href = '/account';
      accountLink.textContent = 'Account';
      headerNav.appendChild(accountLink);
    }
  }

  var authRequiredElements = document.querySelectorAll('[data-auth-required]');
  authRequiredElements.forEach(function (elem) {
    elem.classList.remove('hidden');
  });

  var guestOnlyElements = document.querySelectorAll('[data-guest-only]');
  guestOnlyElements.forEach(function (elem) {
    elem.classList.add('hidden');
  });

}

function normalizeAuthUser(data, email) {
  if (!data) return null;
  var user = data.user_data || data.user || data.data || data;
  if (!user) return null;
  var userEmail = user.email || user.Email || email || '';
  var userId = user.id || user.ID || user.uid || user.user_id || '';
  var secret = user.secret || user.Secret || user.api_key || user.apiKey || '';
  if (!userId && !userEmail && !secret) return null;
  return {
    id: userId,
    email: userEmail,
    name: user.name || user.Name || user.username || user.Username || userEmail,
    username: user.username || user.Username || user.name || user.Name || userEmail,
    secret: secret,
    is_subscribed: user.is_subscribed || user.IsSubscribed || data.is_subscribed || false,
    free_credits: user.free_credits || user.FreeCredits || 0,
    paid_credits: user.paid_credits || user.PaidCredits || 0,
    credits: user.credits || user.Credits || ((user.free_credits || user.FreeCredits || 0) + (user.paid_credits || user.PaidCredits || 0)),
  };
}

function persistAuthUser(user) {
  if (!user) return;
  window.userData = user;
  window.isLoggedIn = true;
  try {
    localStorage.setItem('netwrck_user', JSON.stringify(user));
    if (user.secret) {
      localStorage.setItem('userSecret', user.secret);
    }
  } catch (e) {
    console.warn('[AUTH-MODAL] Could not store user data:', e);
  }
}

async function hydrateAuthUser(data, email) {
  var user = normalizeAuthUser(data, email);
  if (user) {
    persistAuthUser(user);
    return user;
  }
  try {
    var response = await fetch('/api/get-user', {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    if (response.ok) {
      var getUserData = await response.json();
      user = normalizeAuthUser(getUserData, email);
      if (user) {
        persistAuthUser(user);
        return user;
      }
    }
  } catch (e) {
    console.warn('[AUTH-MODAL] Could not hydrate user data:', e);
  }
  return null;
}

function openAuthDialog(dialog, fallbackPath) {
  if (!dialog) return false;
  if (!dialog.__authCloseStyleReset) {
    dialog.__authCloseStyleReset = true;
    dialog.addEventListener('close', function () {
      dialog.style.display = '';
      dialog.style.visibility = '';
      dialog.style.opacity = '';
      dialog.style.position = '';
      dialog.style.top = '';
      dialog.style.left = '';
      dialog.style.transform = '';
      dialog.style.zIndex = '';
    });
  }
  if (!dialog.__authEscapeCloseInstalled) {
    dialog.__authEscapeCloseInstalled = true;
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !dialog.open) return;
      if (dialog.close) {
        try {
          dialog.close();
        } catch (e) {
          dialog.removeAttribute('open');
        }
      } else {
        dialog.removeAttribute('open');
      }
    }, true);
  }
  function makeVisible() {
    dialog.setAttribute('open', '');
    dialog.style.display = 'block';
    dialog.style.visibility = 'visible';
    dialog.style.opacity = '1';
    dialog.style.zIndex = '2147483647';
    dialog.querySelectorAll('#login-email, #login-password, #signup-email, #signup-password, #auth-submit, #signup-submit').forEach(function (el) {
      if (el.closest('.mdl-textfield')) el.closest('.mdl-textfield').style.display = '';
      if (el.closest('.mdl-textfield')) el.closest('.mdl-textfield').style.visibility = 'visible';
      el.style.visibility = 'visible';
      el.style.opacity = '1';
      el.style.display = '';
    });
    dialog.style.position = 'fixed';
    dialog.style.top = '50%';
    dialog.style.left = '50%';
    dialog.style.transform = 'translate(-50%, -50%)';
  }
  dialog.removeAttribute('inert');
  if (dialog.open) {
    makeVisible();
    return true;
  }
  if (typeof dialog.showModal === 'function') {
    try {
      dialog.showModal();
      makeVisible();
      return true;
    } catch (e) {
      if (typeof dialog.show === 'function') {
        try {
          dialog.show();
        } catch (showErr) {
          dialog.setAttribute('open', '');
        }
        makeVisible();
        return true;
      }
      dialog.setAttribute('open', '');
      makeVisible();
      return true;
    }
  }
  if (typeof dialog.show === 'function') {
    try {
      dialog.show();
    } catch (e) {
      dialog.setAttribute('open', '');
    }
    dialog.setAttribute('open', '');
    makeVisible();
    return true;
  }
  if (typeof dialog.setAttribute === 'function') {
    dialog.setAttribute('open', '');
    makeVisible();
    return true;
  }
  window.location.href = fallbackPath;
  return false;
}

function isAuthPath(url, path) {
  if (!url || url.pathname !== path) return false;
  return (
    url.origin === window.location.origin ||
    url.hostname === window.location.hostname ||
    url.hostname === ''
  );
}

function authFunnel() {
  return window.thFunnel || null;
}

function showLoginDialog(event, nextUrl) {
  // Immediately prevent event propagation to avoid popstate issues
  if (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  var dialog = document.getElementById('login-dialog');
  if (!dialog) return false;
  if (authFunnel()) authFunnel().authDialog('login', event);

  var signupDialog = document.getElementById('signup-dialog');
  if (signupDialog && signupDialog.open && typeof signupDialog.close === 'function') {
    signupDialog.close();
  }

  try {
    // If we were redirected here with stored credentials, prefill them
    try {
      const storedEmail = sessionStorage.getItem('prefill_email');
      const storedPass = sessionStorage.getItem('prefill_password');
      if (storedEmail) {
        const le = document.getElementById('login-email');
        if (le) le.value = storedEmail;
      }
      if (storedPass) {
        const lp = document.getElementById('login-password');
        if (lp) lp.value = storedPass;
      }
      if (storedEmail || storedPass) {
        sessionStorage.removeItem('prefill_email');
        sessionStorage.removeItem('prefill_password');
      }
    } catch (e) {
      if (
        typeof process !== 'undefined' &&
        process.env &&
        process.env.VERBOSE_TESTS
      ) {
        console.warn(
          '[AuthModal] Failed reading prefill from sessionStorage:',
          e
        );
      }
    }

    const errorElement = dialog.querySelector('#auth-error');
    if (errorElement) {
      errorElement.textContent = '';
      errorElement.style.display = 'none';
      errorElement.style.visibility = 'hidden';
    }

    const textfields = dialog.querySelectorAll('.mdl-textfield');
    textfields.forEach((field) => field.classList.remove('is-invalid'));

    // Determine and sanitize next URL
    if (!nextUrl || nextUrl === '') {
      nextUrl =
        window.location.pathname +
        window.location.search +
        window.location.hash;
    }
    nextUrl = sanitizeRedirectUrl(nextUrl);

    const nextInput = document.getElementById('login-next');
    if (nextInput) nextInput.value = nextUrl;
    openAuthDialog(dialog, '/login');
  } catch (error) {
    console.error('Error showing login dialog:', error);
    return false;
  }

  return false;
}

function showSignupDialog(event, nextUrl) {
  // Immediately prevent event propagation to avoid popstate issues
  if (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  var dialog = document.getElementById('signup-dialog');
  if (!dialog) return false;
  if (authFunnel()) authFunnel().authDialog('signup', event);

  var loginDialog = document.getElementById('login-dialog');
  if (loginDialog && loginDialog.open && typeof loginDialog.close === 'function') {
    loginDialog.close();
  }

  try {
    const errorElement = dialog.querySelector('#signup-error');
    if (errorElement) {
      errorElement.textContent = '';
      errorElement.style.display = 'none';
      errorElement.style.visibility = 'hidden';
    }

    const textfields = dialog.querySelectorAll('.mdl-textfield');
    textfields.forEach((field) => field.classList.remove('is-invalid'));

    // Determine and sanitize next URL
    if (!nextUrl || nextUrl === '') {
      nextUrl =
        window.location.pathname +
        window.location.search +
        window.location.hash;
    }
    nextUrl = sanitizeRedirectUrl(nextUrl);

    const nextInput = document.getElementById('signup-next');
    if (nextInput) nextInput.value = nextUrl;
    openAuthDialog(dialog, '/signup');
  } catch (error) {
    console.error('Error showing signup dialog:', error);
    return false;
  }

  return false;
}

window.showLoginDialog = showLoginDialog;
window.showSignupDialog = showSignupDialog;

window.handleDialogLogin = async function () {
  var form = document.getElementById('auth-form');
  var emailInput = document.getElementById('login-email');
  var passwordInput = document.getElementById('login-password');
  var errorElement = document.getElementById('auth-error');
  var submitBtn = document.getElementById('auth-submit');
  var nextInput = document.getElementById('login-next');
  var dialog = document.getElementById('login-dialog');

  if (!emailInput || !passwordInput) return false;
  if (submitBtn && submitBtn.disabled) return false;

  var email = emailInput.value.trim();
  var password = passwordInput.value.trim();
  var nextUrl = nextInput && nextInput.value ? nextInput.value : '/';

  if (errorElement) {
    errorElement.textContent = '';
    errorElement.style.display = 'none';
    errorElement.style.visibility = 'hidden';
  }

  if (!email || !password) {
    if (errorElement) {
      errorElement.textContent = 'Please enter email and password';
      errorElement.style.display = 'block';
      errorElement.style.visibility = 'visible';
    }
    if (form) {
      form.querySelectorAll('.mdl-textfield').forEach(function (field) {
        field.classList.add('is-invalid');
      });
    }
    return false;
  }

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Logging in...';
  }
  if (authFunnel()) authFunnel().authStarted('sign_in', 'password');

  try {
    var response = await fetch('/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ email: email, password: password, next: nextUrl }),
      credentials: 'include',
    });
    var data = await response.json();

    if (response.ok && (data.success || data.logged_in)) {
      var authenticatedUser = await hydrateAuthUser(data, email);
      if (dialog && dialog.close) {
        dialog.close();
      }
      updateUIAfterAuth();
      window.dispatchEvent(new CustomEvent('userLoggedIn', { detail: data }));
      if (authFunnel()) authFunnel().authCompleted('sign_in', 'password', authenticatedUser || data);
      if (typeof $ !== 'undefined') {
        $(document).trigger('user-logged-in', [data]);
      }
      var onAuthPage = /^\/(login|signup)(\/|$)/.test(window.location.pathname);
      var redirectTo = data.redirect || data.redirect_url || nextUrl;
      if (onAuthPage && redirectTo) {
        window.location.href = sanitizeRedirectUrl(redirectTo);
      }
      return false;
    }

    if (authFunnel()) authFunnel().authFailed('sign_in', 'password', data.error_code || 'http_' + response.status);
    if (errorElement) {
      errorElement.textContent = data.error || 'Invalid email or password';
      errorElement.style.display = 'block';
      errorElement.style.visibility = 'visible';
    }
    if (form) {
      form.querySelectorAll('.mdl-textfield').forEach(function (field) {
        field.classList.add('is-invalid');
      });
    }
    if (passwordInput) {
      passwordInput.focus();
      passwordInput.select();
    }
  } catch (error) {
    console.error('Login error:', error);
    if (authFunnel()) authFunnel().authFailed('sign_in', 'password', 'network');
    if (errorElement) {
      errorElement.textContent = 'An error occurred. Please try again.';
      errorElement.style.display = 'block';
      errorElement.style.visibility = 'visible';
    }
  } finally {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Login';
    }
  }

  return false;
};

// Double-check after a slight delay to see if they're being overwritten
setTimeout(() => {
  if (typeof window.showLoginDialog !== 'function') {
    console.warn('[AUTH-MODAL] showLoginDialog was overwritten or lost!');
    window.showLoginDialog = showLoginDialog;
  }
  if (typeof window.showSignupDialog !== 'function') {
    console.warn('[AUTH-MODAL] showSignupDialog was overwritten or lost!');
    window.showSignupDialog = showSignupDialog;
  }
}, 100);

window.closeAllAuthModals = function () {
  var loginDialog = document.getElementById('login-dialog');
  var signupDialog = document.getElementById('signup-dialog');

  if (loginDialog && loginDialog.open) {
    loginDialog.close();
  }

  if (signupDialog && signupDialog.open) {
    signupDialog.close();
  }
};

window.switchToLogin = function () {
  var signupDialog = document.getElementById('signup-dialog');
  var loginDialog = document.getElementById('login-dialog');
  if (authFunnel()) authFunnel().paywallClick('login');

  if (signupDialog && signupDialog.open) {
    signupDialog.close();
  }

  if (loginDialog) {
    var signupEmail = document.getElementById('signup-email');
    var loginEmail = document.getElementById('login-email');
    if (signupEmail && loginEmail && signupEmail.value) {
      loginEmail.value = signupEmail.value;
    }

    setTimeout(() => {
      openAuthDialog(loginDialog, '/login');
    }, 100);
  }
};

window.switchToSignup = function (prefill) {
  var loginDialog = document.getElementById('login-dialog');
  var signupDialog = document.getElementById('signup-dialog');
  if (authFunnel()) authFunnel().paywallClick('signup');

  if (loginDialog && loginDialog.open) {
    loginDialog.close();
  }

  if (signupDialog) {
    var loginEmail = document.getElementById('login-email');
    var signupEmail = document.getElementById('signup-email');
    var signupPassword = document.getElementById('signup-password');
    var signupName = document.getElementById('signup-name');

    var email = (prefill && prefill.email) || (loginEmail && loginEmail.value) || '';
    if (signupEmail && email) signupEmail.value = email;
    if (signupPassword && prefill && prefill.password) signupPassword.value = prefill.password;

    var name = prefill && prefill.name !== undefined ? prefill.name : (email ? email.split('@')[0].replace(/[._-]+/g, ' ') : '');
    if (signupName) signupName.value = name;

    setTimeout(() => {
      openAuthDialog(signupDialog, '/signup');
      if (signupName && signupName.value) {
        signupName.focus();
        try { signupName.select(); } catch(e) {}
      } else if (signupEmail && !signupEmail.value) {
        signupEmail.focus();
      }
    }, 80);
  }
};

// Add logout handler to clear localStorage
window.handleLogout = function () {
  // Clear localStorage
  try {
    localStorage.removeItem('netwrck_user');
    localStorage.removeItem('userSecret');
    localStorage.removeItem('userData');
  } catch (e) {
    console.warn('[AUTH-MODAL] Could not clear localStorage:', e);
  }

  // Clear window.userData
  window.userData = {};

  // Redirect to logout endpoint
  window.location.href = '/logout';
};

window.initAuthModals = function () {
  if (window.authModalInitialized) return;
  window.authModalInitialized = true;

  // Check if user is logged in and update UI
  if (window.userData && window.userData.id && window.userData.email) {
    updateUIAfterAuth();
  }

  // Ensure all dialog close buttons work reliably via event delegation
  if (!window.__dialogCloseDelegationInstalled) {
    window.__dialogCloseDelegationInstalled = true;
    document.addEventListener(
      'click',
      function (e) {
        try {
          // Support a broad set of close button selectors
          const closeEl =
            e.target && e.target.closest
              ? e.target.closest(
                  'button.close, .close, .close-dialog, .modal-close, [data-dismiss="modal"], [data-dismiss="dialog"], [data-dialog-close], [data-close]'
                )
              : null;
          if (!closeEl) return;

          const container = closeEl.closest
            ? closeEl.closest('dialog, .mdl-dialog')
            : null;
          if (!container) return;

          const nativeDialog =
            container.tagName && container.tagName.toLowerCase() === 'dialog'
              ? container
              : (container.querySelector &&
                  container.querySelector('dialog')) ||
                container;

          if (nativeDialog) {
            if (typeof nativeDialog.close === 'function' && nativeDialog.open) {
              nativeDialog.close();
              nativeDialog.style && (nativeDialog.style.display = '');
            } else {
              nativeDialog.removeAttribute &&
                nativeDialog.removeAttribute('open');
              if (nativeDialog.style) {
                nativeDialog.style.display = '';
                nativeDialog.style.visibility = '';
                nativeDialog.style.opacity = '';
              }
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        } catch (err) {
          // Non-fatal; keep UX responsive
          console.warn('[AUTH-MODAL] Close delegation error:', err);
        }
      },
      true
    );

    // Backdrop/background click: close dialog when clicking outside content
    document.addEventListener(
      'click',
      function (e) {
        try {
          const target = e.target;
          if (!target || !target.tagName) return;
          // For native <dialog>, clicks on the backdrop set event.target to the dialog element
          if (target.tagName.toLowerCase() !== 'dialog') return;

          // Allow opting out via data-backdrop="static"
          const allowBackdropClose =
            target.getAttribute('data-backdrop') !== 'static';
          if (!allowBackdropClose) return;

          let isBackdropClick = false;
          if (typeof window.__isDialogBackdropClick === 'function') {
            isBackdropClick = window.__isDialogBackdropClick(target, e) === true;
          } else if (
            typeof target.getBoundingClientRect === 'function' &&
            Number.isFinite(e.clientX) &&
            Number.isFinite(e.clientY) &&
            (e.clientX !== 0 || e.clientY !== 0)
          ) {
            const rect = target.getBoundingClientRect();
            isBackdropClick =
              e.clientX < rect.left ||
              e.clientX > rect.right ||
              e.clientY < rect.top ||
              e.clientY > rect.bottom;
          }
          if (!isBackdropClick) return;

          if (typeof target.close === 'function' && target.open) {
            target.close();
            target.style && (target.style.display = '');
          } else {
            target.removeAttribute && target.removeAttribute('open');
            if (target.style) {
              target.style.display = '';
              target.style.visibility = '';
              target.style.opacity = '';
            }
          }
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        } catch (err) {
          console.warn('[AUTH-MODAL] Backdrop close handler error:', err);
        }
      },
      true
    );
  }
  // Update all login/signup links to include ?next= parameter
  function updateAuthLinks() {
    var currentPath =
      window.location.pathname + window.location.search + window.location.hash;

    // Update login links
    var loginLinks = document.querySelectorAll(
      'a[href="/login"], a[href*="/login"]'
    );
    loginLinks.forEach(function (link) {
      // Skip if it already has onclick handler for modal
      if (link.onclick && link.onclick.toString().includes('showLoginDialog')) {
        return;
      }

      // Add ?next= parameter if not present
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.pathname === '/login' && !url.searchParams.has('next')) {
          url.searchParams.set('next', currentPath);
          link.href = url.toString();
        }
      } catch (e) {
        // Skip if URL parsing fails
      }
    });

    // Update signup links
    var signupLinks = document.querySelectorAll(
      'a[href="/signup"], a[href*="/signup"]'
    );
    signupLinks.forEach(function (link) {
      // Skip if it already has onclick handler for modal
      if (
        link.onclick &&
        link.onclick.toString().includes('showSignupDialog')
      ) {
        return;
      }

      // Add ?next= parameter if not present
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.pathname === '/signup' && !url.searchParams.has('next')) {
          url.searchParams.set('next', currentPath);
          link.href = url.toString();
        }
      } catch (e) {
        // Skip if URL parsing fails
      }
    });
  }

  // Update links on page load
  updateAuthLinks();

  // Update links when DOM changes (for dynamically added content)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });
      if (shouldUpdate) {
        updateAuthLinks();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (!window.__authModalLinkDelegationInstalled) {
    window.__authModalLinkDelegationInstalled = true;
    document.addEventListener(
      'click',
      function (e) {
        var link =
          e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!link) return;

        var url = null;
        try {
          url = new URL(link.getAttribute('href'), window.location.origin);
        } catch (err) {
          return;
        }

        var nextUrl =
          window.location.pathname + window.location.search + window.location.hash;

        if (isAuthPath(url, '/login') && document.getElementById('login-dialog')) {
          showLoginDialog(e, url.searchParams.get('next') || nextUrl);
          return;
        }

        if (isAuthPath(url, '/signup') && document.getElementById('signup-dialog')) {
          showSignupDialog(e, url.searchParams.get('next') || nextUrl);
        }
      },
      true
    );
  }

  var loginLinks = document.querySelectorAll('.login-modal-link');
  loginLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var nextUrl =
        link.href && link.href.includes('?next=')
          ? new URL(link.href).searchParams.get('next')
          : '/';
      showLoginDialog(e, nextUrl);
      return false;
    });
  });

  var signupLinks = document.querySelectorAll('.signup-link');
  signupLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var nextUrl =
        link.href && link.href.includes('?next=')
          ? new URL(link.href).searchParams.get('next')
          : '/';
      showSignupDialog(e, nextUrl);
      return false;
    });
  });

  if (
    window.location.pathname === '/login' &&
    window.location.hash === '#modal'
  ) {
    var nextUrl =
      new URLSearchParams(window.location.search).get('next') || '/';
    showLoginDialog(null, nextUrl);

    window.history.replaceState({}, document.title, nextUrl);
  }

  if (
    window.location.pathname === '/signup' &&
    window.location.hash === '#modal'
  ) {
    let signupNextUrl =
      new URLSearchParams(window.location.search).get('next') || '/';
    showSignupDialog(null, signupNextUrl);

    window.history.replaceState({}, document.title, signupNextUrl);
  }

  var loginDialog = document.getElementById('login-dialog');
  if (loginDialog) {
    var loginCloseBtn = loginDialog.querySelector('.close');
    if (loginCloseBtn) {
      loginCloseBtn.addEventListener('click', function (e) {
        loginDialog.close();
        e.preventDefault();
        e.stopPropagation();
      });
    }
    var loginForm = document.getElementById('auth-form');
    var loginSubmitBtn = document.getElementById('auth-submit');

    if (loginForm && loginForm.dataset.bound !== 'true') {
      loginForm.dataset.bound = 'true';
      loginForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (loginSubmitBtn && loginSubmitBtn.disabled) return;
        const formData = new FormData(loginForm);
        const jsonData = {
          email: formData.get('email'),
          password: formData.get('password'),
          next: formData.get('next') || '/',
        };

        loginSubmitBtn.disabled = true;
        loginSubmitBtn.textContent = 'Logging in...';
        if (authFunnel()) authFunnel().authStarted('sign_in', 'password');

        try {
          const response = await fetch('/api/login', {
            method: 'POST',
            body: JSON.stringify(jsonData),
            credentials: 'include',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          });

          let data;
          try {
            data = await response.json();
          } catch (jsonError) {
            // Handle case where server returns HTML instead of JSON (e.g., ebank domain issue)
            console.error(
              '[AUTH-MODAL] Failed to parse JSON response:',
              jsonError
            );
            // If response was OK but JSON parsing failed, assume success (redirect case)
            if (response.ok) {
              data = {
                success: true,
                user: {},
              };
            } else {
              data = {
                success: false,
                error: 'Invalid email or password',
                error_code: 'authentication_failed',
              };
            }
          }

          if (response.ok && data.success) {
            window.__netwrckLogoutStartedAt = 0;
            window.__netwrckLogoutBlockSessionSave = false;
            try {
              sessionStorage.removeItem('netwrck_logout_pending');
            } catch { /* Error ignored */ }

            if (data.user_data) {
              window.userData = {
                id: data.user_data.id,
                email: data.user_data.email,
                name: data.user_data.name,
                secret: data.user_data.secret,
                is_subscribed: data.user_data.is_subscribed || data.is_subscribed,
                free_credits: data.user_data.free_credits || 0,
                paid_credits: data.user_data.paid_credits || 0,
                credits: data.user_data.credits || ((data.user_data.free_credits || 0) + (data.user_data.paid_credits || 0)),
              };
              try {
                localStorage.setItem('netwrck_user', JSON.stringify(window.userData));
                if (window.userData.secret) {
                  localStorage.setItem('userSecret', window.userData.secret);
                }
              } catch (e) {
                console.warn('[AUTH-MODAL] Could not store in localStorage:', e);
              }
            }

            loginDialog.close();

            if (window.authSession) {
              const authResult = await window.authSession.checkStatus();
            } else if (!data.user_data) {
              try {
                const userResponse = await fetch('/api/get-user', {
                  credentials: 'include',
                  headers: { Accept: 'application/json' },
                });
                if (userResponse.ok) {
                  const userData = await userResponse.json();
                  if (userData.success && userData.data) {
                    window.userData = {
                      id: userData.data.id,
                      email: userData.data.email,
                      name: userData.data.name || userData.data.username || userData.data.email,
                      secret: userData.data.secret,
                      is_subscribed: userData.data.is_subscribed,
                      free_credits: userData.data.free_credits || 0,
                      paid_credits: userData.data.paid_credits || 0,
                      credits: userData.data.credits || ((userData.data.free_credits || 0) + (userData.data.paid_credits || 0)),
                    };
                    try {
                      localStorage.setItem('netwrck_user', JSON.stringify(window.userData));
                      if (window.userData.secret) {
                        localStorage.setItem('userSecret', window.userData.secret);
                      }
                    } catch (e) {
                      console.warn('[AUTH-MODAL] Could not store in localStorage:', e);
                    }
                  }
                }
              } catch (err) {
                console.error('[AUTH-MODAL] Error fetching user data:', err);
              }
            }


            updateUIAfterAuth();

            if (typeof window.resumePendingEbankArtGeneration === 'function') {
              window.resumePendingEbankArtGeneration();
            }

            setTimeout(() => {
              window.dispatchEvent(
                new CustomEvent('userLoggedIn', { detail: data })
              );
              if (authFunnel()) authFunnel().authCompleted('sign_in', 'password', data);
            }, 50);

            return;
          }

          if (authFunnel()) authFunnel().authFailed('sign_in', 'password', data.error_code || 'http_' + response.status);
          const errorElement = loginForm.querySelector('#auth-error');
          const passwordField =
            loginForm.querySelector('#login-password') ||
            document.getElementById('login-password');
          const passwordContainer = passwordField
            ? passwordField.closest('.mdl-textfield')
            : null;

          if (errorElement) {
            // Set error message based on error type
            let errorMessage = 'Login failed. Please try again.';

            if (data.error_code === 'user_not_found') {
              errorMessage = data.error || 'Invalid email or password';
            } else if (data.error) {
              errorMessage = data.error;
            } else if (data.error_code === 'authentication_failed') {
              errorMessage = 'Invalid email or password';
            } else if (response.status === 401) {
              errorMessage = 'Invalid email or password';
            } else if (response.status === 400) {
              errorMessage =
                data.error || 'Invalid input. Please check your details.';
            } else if (response.status === 404 || data.error_code === 'user_not_found') {
              errorMessage = data.error || 'Invalid email or password';
            }

            errorElement.textContent = errorMessage;
            errorElement.style.display = 'block';
            errorElement.style.visibility = 'visible';

            // Add shake animation and focus password field
            if (passwordContainer) {
              passwordContainer.classList.add('is-invalid');

              // Add shake animation
              loginDialog.classList.add('shake');
              setTimeout(() => {
                loginDialog.classList.remove('shake');
              }, 500);

              // Clear and focus password field
              passwordField.value = '';
              passwordField.focus();
            }

            const textfields = loginForm.querySelectorAll('.mdl-textfield');
            textfields.forEach((field) => field.classList.add('is-invalid'));
          }
        } catch (error) {
          console.error('Login error:', error);
          if (authFunnel()) authFunnel().authFailed('sign_in', 'password', 'network');
          const errorElement = loginForm.querySelector('#auth-error');
          if (errorElement) {
            errorElement.textContent =
              'Network error. Please check your connection and try again.';
            errorElement.style.display = 'block';
            errorElement.style.visibility = 'visible';

            const textfields = loginForm.querySelectorAll('.mdl-textfield');
            textfields.forEach((field) => field.classList.add('is-invalid'));
          }
        } finally {
          loginSubmitBtn.disabled = false;
          loginSubmitBtn.textContent = 'Login';
        }
      });
    }
  }

  var signupDialog = document.getElementById('signup-dialog');
  if (signupDialog) {
    var signupCloseBtn = signupDialog.querySelector('.close');
    if (signupCloseBtn) {
      signupCloseBtn.addEventListener('click', function (e) {
        signupDialog.close();
        e.preventDefault();
        e.stopPropagation();
      });
    }

    var signupForm = document.getElementById('signup-form');
    if (signupForm && signupForm.dataset.bound !== 'true') {
      signupForm.dataset.bound = 'true';
      signupForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        const formData = new FormData(signupForm);
        const submitBtn = signupForm.querySelector('#signup-submit');
        if (submitBtn && submitBtn.disabled) return;

        submitBtn.disabled = true;
        submitBtn.textContent = 'Signing up...';
        if (authFunnel()) authFunnel().authStarted('sign_up', 'password');

        try {

          const signupData = {
            email: formData.get('email'),
            password: formData.get('password'),
          };

          const response = await fetch('/api/create-user', {
            method: 'POST',
            body: JSON.stringify(signupData),
            credentials: 'include',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          });


          if (response.ok) {
            const data = await response.json();

            if (data.success) {
              window.__netwrckLogoutStartedAt = 0;
              window.__netwrckLogoutBlockSessionSave = false;
              try {
                sessionStorage.removeItem('netwrck_logout_pending');
              } catch { /* Error ignored */ }
              signupDialog.close();

              var u = data.user_data || data.user || data.data;
              if (u) {
                window.userData = {
                  id: u.id || data.id,
                  email: u.email || data.email,
                  name: u.name || u.username || data.email,
                  secret: u.secret || u.api_key || data.api_key,
                  is_subscribed: u.is_subscribed || data.is_subscribed || false,
                  free_credits: u.free_credits || data.free_credits || 0,
                  paid_credits: u.paid_credits || data.paid_credits || 0,
                  credits: u.credits || data.credits || ((u.free_credits || data.free_credits || 0) + (u.paid_credits || data.paid_credits || 0)),
                };
                try {
                  localStorage.setItem('netwrck_user', JSON.stringify(window.userData));
                  if (window.userData.secret) {
                    localStorage.setItem('userSecret', window.userData.secret);
                  }
                } catch (e) {
                  console.warn('[AUTH-MODAL] Could not store in localStorage:', e);
                }
              }

              if (window.authSession) {
                await window.authSession.checkStatus();
                // After checkStatus, userData should be populated
              } else {

                try {
                  const userResponse = await fetch('/api/get-user', {
                    credentials: 'include',
                    headers: { Accept: 'application/json' },
                  });
                  if (userResponse.ok) {
                    const userData = await userResponse.json();
                    if (userData.success && userData.data) {
                      window.userData = {
                        id: userData.data.id,
                        email: userData.data.email,
                        name:
                          userData.data.name ||
                          userData.data.username ||
                          userData.data.email,
                        secret: userData.data.secret,
                        is_subscribed: userData.data.is_subscribed,
                        credits: userData.data.credits || ((userData.data.free_credits || 0) + (userData.data.paid_credits || 0)),
                      };

                      // Store in localStorage for persistence
                      try {
                        localStorage.setItem(
                          'netwrck_user',
                          JSON.stringify(window.userData)
                        );
                        localStorage.setItem(
                          'userSecret',
                          window.userData.secret || ''
                        );
                      } catch (e) {
                        console.warn(
                          '[SIGNUP] Could not store in localStorage:',
                          e
                        );
                      }

                      if (
                        !window.userData.secret ||
                        window.userData.secret === ''
                      ) {
                        const newSecret = 'sk_' + generateRandomString(32);
                        window.userData.secret = newSecret;

                        try {
                          await fetch('/api/update-user-secret', {
                            method: 'POST',
                            credentials: 'include',
                            headers: {
                              'Content-Type': 'application/json',
                              Accept: 'application/json',
                            },
                            body: JSON.stringify({ secret: newSecret }),
                          });
                        } catch (secretErr) {
                          console.error(
                            '[SIGNUP] Failed to update secret on server:',
                            secretErr
                          );
                        }
                      }
                    }
                  }
                } catch (err) {
                  console.error('Error fetching user data after signup:', err);
                }
              }


              const resumedPendingArt =
                typeof window.resumePendingEbankArtGeneration === 'function' &&
                window.resumePendingEbankArtGeneration();

              window.dispatchEvent(
                new CustomEvent('userSignedUp', { detail: data })
              );
              if (authFunnel()) authFunnel().authCompleted('sign_up', 'password', data);

              const isEbankDomain = window.location.hostname.includes('ebank');

              if (isEbankDomain && !resumedPendingArt) {
                setTimeout(() => {
                  if (
                    window.EmbeddedCheckout &&
                    typeof window.EmbeddedCheckout.open === 'function'
                  ) {
                    window.EmbeddedCheckout.open({
                      type: 'subscription',
                      amount: 'monthly',
                    });
                  } else {
                    window.location.href = '/ebankaccount';
                  }
                }, 500);
              } else {
                setTimeout(() => {

                  if (
                    window.sessionStorage.getItem('skippedProfile') === 'true'
                  ) {
                    return;
                  }

                  if (
                    window.userData &&
                    window.userData.name &&
                    window.userData.greeting &&
                    (window.userData.avatar_photo_url ||
                      window.userData.avatar_file_name)
                  ) {
                  } else {
                    var addUserDialog =
                      document.getElementById('add-user-dialog');
                    if (
                      addUserDialog &&
                      typeof addUserDialog.showModal === 'function'
                    ) {

                      addUserDialog.addEventListener(
                        'close',
                        function onClose() {
                          addUserDialog.removeEventListener('close', onClose);
                        }
                      );
                      addUserDialog.showModal();
                    } else {
                      console.warn(
                        'add-user-dialog element not found or showModal not available'
                      );
                    }
                  }
                }, 500);
              }

              updateUIAfterAuth();
              return;
            } else {
              console.error('Signup failed with success=false:', data);
            }
            if (authFunnel()) authFunnel().authFailed('sign_up', 'password', data.error_code || 'rejected');

            const errorElement = signupForm.querySelector('#signup-error');
            const msg = (data && (data.error || data.message)) || '';
            // If account already exists, jump to login and prefill
            if (/already\s+exists|already\s+registered/i.test(msg)) {
              try {
                if (signupDialog && signupDialog.open) signupDialog.close();
                const loginDialogEl = document.getElementById('login-dialog');
                const loginEmailEl = document.getElementById('login-email');
                const loginPassEl = document.getElementById('login-password');
                const enteredEmail =
                  signupData.email || formData.get('email') || '';
                const enteredPassword =
                  signupData.password || formData.get('password') || '';
                if (loginEmailEl) loginEmailEl.value = enteredEmail;
                if (loginPassEl) loginPassEl.value = enteredPassword;
                if (
                  loginDialogEl &&
                  typeof loginDialogEl.showModal === 'function'
                ) {
                  loginDialogEl.showModal();
                } else {
                  try {
                    sessionStorage.setItem('prefill_email', enteredEmail);
                    sessionStorage.setItem('prefill_password', enteredPassword);
                  } catch (e) {
                    if (
                      typeof process !== 'undefined' &&
                      process.env &&
                      process.env.VERBOSE_TESTS
                    ) {
                      console.warn(
                        '[AuthModal] Failed writing prefill to sessionStorage:',
                        e
                      );
                    }
                  }
                  window.location.href = '/login#modal';
                }
                return;
              } catch (switchErr) {
                // If switching fails, fall through to show a message
              }
            }
            if (errorElement) {
              errorElement.textContent =
                msg || 'Signup failed. Please try again.';
              errorElement.style.display = 'block';
              errorElement.style.visibility = 'visible';
            }
            return;
          }

          if (authFunnel()) authFunnel().authFailed('sign_up', 'password', 'http_' + response.status);
          console.error(
            'Signup HTTP error - Status:',
            response.status,
            'StatusText:',
            response.statusText
          );

          const errorElement = signupForm.querySelector('#signup-error');
          if (errorElement) {
            if (response.status === 400) {
              const errorData = await response.json();
              console.error('400 error data:', errorData);
              errorElement.textContent =
                errorData.error || 'Invalid input. Please check your details.';
              errorElement.style.display = 'block';
              errorElement.style.visibility = 'visible';
            } else if (response.status === 409) {

              // Show error message first
              errorElement.textContent =
                'An account with this email already exists. Please use the login form instead.';
              errorElement.style.display = 'block';
              errorElement.style.visibility = 'visible';

              // Wait a moment for user to see the message, then switch to login
              setTimeout(() => {
                // Try to switch to the login dialog and prefill credentials
                try {
                  // Close signup dialog first
                  if (signupDialog && signupDialog.open) signupDialog.close();

                  // Prefill login modal if available
                  const loginDialogEl = document.getElementById('login-dialog');
                  const loginEmailEl = document.getElementById('login-email');
                  const loginPassEl = document.getElementById('login-password');

                  // Use the same values the user just entered
                  const enteredEmail =
                    signupData.email || formData.get('email') || '';
                  const enteredPassword =
                    signupData.password || formData.get('password') || '';

                  if (loginEmailEl) loginEmailEl.value = enteredEmail;
                  if (loginPassEl) loginPassEl.value = enteredPassword;

                  if (
                    loginDialogEl &&
                    typeof loginDialogEl.showModal === 'function'
                  ) {
                    loginDialogEl.showModal();
                  } else {
                    // Fallback for pages without modal: persist and redirect to login
                    try {
                      sessionStorage.setItem('prefill_email', enteredEmail);
                      sessionStorage.setItem(
                        'prefill_password',
                        enteredPassword
                      );
                    } catch (e) {
                      console.warn(
                        'Failed to access sessionStorage for prefill'
                      );
                    }
                    // Prefer modal on login page if available
                    window.location.href = '/login#modal';
                  }
                } catch (switchErr) {
                  console.error('Failed to switch to login dialog:', switchErr);
                  // As a last resort, at least show a clear message
                  errorElement.textContent =
                    'An account with this email already exists. Please log in.';
                  errorElement.style.display = 'block';
                  errorElement.style.visibility = 'visible';
                }
              }, 2000); // Show error message for 2 seconds before switching
            } else {
              console.error('Unexpected status code:', response.status);
              errorElement.textContent = 'Signup failed. Please try again.';
              errorElement.style.display = 'block';
              errorElement.style.visibility = 'visible';
            }
          }
        } catch (error) {
          if (authFunnel()) authFunnel().authFailed('sign_up', 'password', 'network');
          console.error('Signup network/parse error:', error);
          console.error('Error details:', {
            message: error.message,
            stack: error.stack,
            name: error.name,
          });
          const errorElement = signupForm.querySelector('#signup-error');
          if (errorElement) {
            errorElement.textContent =
              'Network error. Please check your connection and try again.';
            errorElement.style.display = 'block';
            errorElement.style.visibility = 'visible';
          }
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Sign Up';
        }
      });
    }
  }
};
document.addEventListener('DOMContentLoaded', window.initAuthModals);
